export class GetPendingNewsListRequest {
    KeywordSearches: string[];
    PageNumber: number;
    ItemsPerPage: number;
    Sorting: number;
    StatusSearch: number;
}
